/*
  Gestapelde onthulling.

  Blokken binnen een gemarkeerde sectie komen na elkaar in beeld in plaats van
  allemaal tegelijk. Dat leest als een volgorde, en bij de stappen-sectie ís er
  ook een volgorde: eerst 1, dan 2, dan 3, dan 4.

  De standaardtoestand is zichtbaar. Pas als dit script draait wordt er iets
  verborgen, en alleen dan. Zonder JavaScript, of met bewegingsvoorkeur uit,
  staat alles er gewoon.
*/
(function () {
  var STAP_MS = 130;
  var MAX_MS = 900;

  function wilGeenBeweging() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function regel(groep) {
    var items = Array.prototype.slice.call(groep.querySelectorAll('[data-onthul-item]'));
    if (!items.length) return;

    items.forEach(function (el, i) {
      el.style.setProperty('--lez-onthul-vertraging', Math.min(i * STAP_MS, MAX_MS) + 'ms');
    });

    /* Nu pas verbergen: tot dit moment was alles zichtbaar. */
    groep.classList.add('is-klaar');

    var waarnemer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-onthuld');
          waarnemer.unobserve(e.target);
        });
      },
      /* Pas starten als het blok echt in beeld komt, niet al bij de rand. */
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    waarnemer.observe(groep);
  }

  function init() {
    if (wilGeenBeweging() || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-onthul]').forEach(function (groep) {
      if (groep.dataset.onthulKlaar) return;
      groep.dataset.onthulKlaar = '1';
      regel(groep);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* De thema-editor bouwt secties opnieuw op. */
  document.addEventListener('shopify:section:load', init);
})();
